import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/subject';
import { listNavigator } from 'sagas/common';
import { filters } from 'filters/subject';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Subject', actions, selectors, filters } );
}
